<div class="p-breadcrumb p-component">
  <ol class="p-breadcrumb-list">
    <li class="p-breadcrumb-home">
      <a routerLink="/" class="p-menuitem-link" (click)="itemClick($event, home)" target="_self">
        <span class="p-menuitem-icon pi pi-home"></span>
        <span class="p-menuitem-text"> {{ home.label | translate }}</span>
      </a>
    </li>
    <li class="p-menuitem-separator pi pi-chevron-right" *ngIf="menuItems && home"></li>
    <ng-template ngFor let-item let-end="last" [ngForOf]="menuItems">
      <li>
        <a routerLink="{{ item.url }}" class="p-menuitem-link" (click)="itemClick($event, item)" [ngClass]="{'disabled' : item.disabled}">
          <ng-container *ngIf="item.label">
            <span class="p-menuitem-text"> {{ item.label | translate }}</span>
          </ng-container>
        </a>
      </li>
      <li class="p-menuitem-separator pi pi-chevron-right" *ngIf="!end"></li>
    </ng-template>
  </ol>
</div>
